export default class Tangled {
    /**
     * @param {any} application_guid
     */
    constructor(application_guid) {
        this.application_guid = application_guid;
        this.message_count = 1;
        this.event_handler = {};
        this.user_data = {};
        const match = /iframe_guid=(?<iframe_guid>.*)/.exec(window.location.hash||window.location.search);
        if (match && match.groups?.iframe_guid) {
            this.iframe_guid = match.groups.iframe_guid;
        }
        console.debug(`tangled sdk loaded for frame guid ${this.iframe_guid}`);
        window.addEventListener('message', (event) => {
            const data = event.data;
            const callback = this.event_handler[data.tangled_application_message_id];
            if (callback) {
                delete data['tangled_application_message_id'];
                callback(data);
            }
        });
    }

    /**
     * @param {{ action: string; application_guid: any; application_fee?: any; amount?: any; message?: any; }} data
     */
    async _send(data) {
        return new Promise((resolve) => {
            const tangled_application_message_id = this.message_count;
            this.message_count++;
            this.event_handler[tangled_application_message_id] = resolve;
            window.parent.postMessage(
                {
                    ...data,
                    tangled_application_message_id,
                    iframe_guid: this.iframe_guid,
                    type: 'tangled_application_message',
                },
                '*',
            );
        });
    }

    /**
     * @param {{}} data
     */
    setUserData(data) {
        this.user_data = data;
    }

    /**
     * get user data
     * @returns user
     */
    async getUserData() {
        return this._send({
            action: 'get_user_data',
            application_guid: this.application_guid,
        });
    }

    /**
     * request payment from user
     * @param {any} amount number|string
     * @param {any} feeAmount number|string
     * @param {any} message string?
     * @return transaction object {transactionId: string}
    error  object {message: string, code: int}
     */
    async requestPayment(
        amount,
        feeAmount,
        message,
    ) {
        return this._send({
            action: 'send_user_to_application_payment',
            application_guid: this.application_guid,
            application_fee: feeAmount,
            amount,
            message,
        });
    }
}
